module.exports = __webpack_public_path__ + "static/media/farol-logo-novo.075a45c6.svg";